import moment from "moment";
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { Icon } from "@iconify-icon/react";

interface CredentialsProps {
  userProfile: any;
}

const Credentials = (props: CredentialsProps) => {
  return (
    <div key={0} className="content">
      <Card className="contentCard">
        <CardHeader className="contentHeader">
          <CardTitle className="contentTitle">
            <Icon className="cardIcon" icon="line-md:list-3-filled" />
            Credentials
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="editProfile-container">
            <div className="grid">
              <div className="card">
                <h3 className="sectionTitle">Credentialing Information</h3>
                <div className="detailRow">
                  <span className="label">Certification #</span>
                  <span className="value">
                    {props.userProfile?.CertificationNumber}
                  </span>
                </div>
                <div className="detailRow">
                  <span className="label">Analyst Level</span>
                  <span className="value">
                    {props.userProfile?.AnalystLevel}
                  </span>
                </div>
                <div className="detailRow">
                  <span className="label">BACB ID</span>
                  <span className="value">
                    {props.userProfile?.ApplicantBACBID}
                  </span>
                </div>
                <div className="detailRow">
                  <span className="label">County Of Service</span>
                  <span className="value">
                    {props.userProfile?.County?.replaceAll(";", ", ")}
                  </span>
                </div>
                <div className="detailRow">
                  <span className="label">CAQH Number</span>
                  <span className="value">{props.userProfile?.CAQHNumber}</span>
                </div>
                <div className="detailRow">
                  <span className="label">CAQH Completion</span>
                  <span className="value">
                    {props.userProfile?.CAQHReattest &&
                      moment(props.userProfile.CAQHReattest).format(
                        "MM/DD/YYYY",
                      )}
                  </span>
                </div>
                <div className="detailRow">
                  <span className="label">NPI</span>
                  <span className="value">{props.userProfile?.NPI}</span>
                </div>
                <div className="detailRow">
                  <span className="label">NPI Enumeration</span>
                  <span className="value">
                    {props.userProfile?.NPIEnumerationDate}
                  </span>
                </div>
                <div className="detailRow">
                  <span className="label">NPI Taxonomy</span>
                  <span className="value">
                    {props.userProfile?.NPITaxonomy}
                  </span>
                </div>
                <div className="detailRow">
                  <span className="label">Insurance Companies</span>
                  <span className="value">
                    {props.userProfile?.InsuranceCompanies?.replaceAll(
                      "|",
                      ", ",
                    )}
                  </span>
                </div>
                <div className="detailRow">
                  <span className="label">Previously Credentialed</span>
                  <span className="value pill">
                    {props.userProfile?.PreviouslyCredentialed ? (
                      <span className="pillGreen">Yes</span>
                    ) : (
                      <span className="pillRed">No</span>
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Credentials;
